var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1338 0C19.3735 0.00024608 21.9998 2.6265 22 5.86621V16.1338C21.9998 19.3735 19.3735 21.9998 16.1338 22H5.86621C2.6265 21.9998 0.000246436 19.3735 0 16.1338V5.86621C0.000246082 2.6265 2.6265 0.000246434 5.86621 0H16.1338ZM11.6514 9.70801L8.88281 5.99316L5.59668 5.97754L9.83691 11.6689L5.50879 16.2949L6.23926 16.5527L10.2744 12.2559L13.1973 16.1787H16.4746L12.083 10.2871L16.0908 6.02246L15.3711 5.73535L11.6514 9.70801ZM8.34082 7.06543L14.334 15.1055L13.7354 15.1045L7.74316 7.06152L8.34082 7.06543Z",
    fill: "#737373"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.503db3070b3f7f3f61286d8957ab4abf.svg";
export { ForwardRef as ReactComponent };